<template>
  <div class="player">
    <van-popup v-model="showPicker" round position="bottom">
      <van-picker show-toolbar :columns="columns" @cancel="showPicker = false" @confirm="onConfirm" />
    </van-popup>
    <div class="top">{{ data.name }} | {{ data.number }}</div>
    <div class="bottom">
      <div class="item">
        <div class="label">底线击落地球：</div>
        <div class="score-area">
          <m-input
            v-model="items[0].score"
            @blur="edit(items[0])"
            :readonly="info.role !== 1 && info.role !== 4"
            style="width: 50%"
            type="number"
          >
            <template #right-icon>
              <span>分</span>
            </template>
          </m-input>
          <van-rate v-model="items[0].stars" readonly :size="18" color="#ffd21e" void-icon="star" void-color="#eee" />
        </div>
      </div>
      <div class="item">
        <div class="label">上手发球：</div>
        <div class="score-area">
          <m-input
            v-model="items[1].score"
            @blur="edit(items[1])"
            :readonly="info.role !== 2 && info.role !== 4"
            style="width: 50%"
            type="number"
          >
            <template #right-icon>
              <span>分</span>
            </template>
          </m-input>
          <van-rate v-model="items[1].stars" readonly :size="18" color="#ffd21e" void-icon="star" void-color="#eee" />
        </div>
      </div>
      <div class="item">
        <div class="label">实战评定：</div>
        <div class="score-area">
          <m-input
            :value="items[2].score | show_rate"
            :class="{ rate: info.role === 3 || info.role === 4 }"
            @click.native="
              () => {
                if (info.role === 3 || info.role === 4) {
                  showPicker = true
                }
              }
            "
            readonly
            style="width: 50%"
          >
          </m-input>
          <van-rate v-model="items[2].stars" readonly :size="18" color="#ffd21e" void-icon="star" void-color="#eee" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MInput from './MInput'
import { editJudgeInfo } from '../../libs/api'

export default {
  components: {
    MInput,
  },
  props: {
    data: Object,
  },
  filters: {
    show_rate(val) {
      if (!val) return '未选择'
      const arr = ['一星', '二星', '三星', '四星', '五星']
      return arr[val - 1]
    },
  },
  data() {
    return {
      showPicker: false,
      items: [
        { score: null, stars: null, itemid: 1 },
        { score: null, stars: null, itemid: 2 },
        { score: '未选择', stars: null, itemid: 3 },
      ],
      info: {},
      columns: [
        { text: '未选择', value: null },
        { text: '一星', value: 1 },
        { text: '二星', value: 2 },
        { text: '三星', value: 3 },
        { text: '四星', value: 4 },
        { text: '五星', value: 5 },
      ],
    }
  },
  mounted() {
    const info = localStorage.getItem('judge_info')
    this.info = JSON.parse(info)
    const arr = this.data.fivescore || []

    const items = [...this.items]
    arr.forEach((row) => {
      const itemid = Number(row.itemid)
      row.score = Number(row.score)
      row.stars = Number(row.stars)
      if (itemid === 1) {
        items[0] = Object.assign({}, items[0], row)
      } else if (itemid === 2) {
        items[1] = Object.assign({}, items[1], row)
      } else if (itemid === 3) {
        items[2] = Object.assign({}, items[2], row)
      }
    })

    this.items = items
  },
  methods: {
    onConfirm(item) {
      this.items[2].score = item.value
      this.showPicker = false

      if (item.value) {
        this.$nextTick(() => {
          this.edit(this.items[2])
        })
      }
    },
    edit(item) {
      const itemid = item.itemid
      if (
        this.info.role != 4 &&
        ((itemid == 1 && this.info.role != 1) || (itemid == 2 && this.info.role != 2) || (itemid == 3 && this.info.role != 3))
      ) {
        return
      }
      const params = {
        judgeid: this.info.judgeid,
        token: this.info.token,
        matchid: this.$route.query.matchid,
        itemid: item.itemid,
        number: this.data.number,
        score: item.score,
      }
      editJudgeInfo(params).then((r) => {
        if (Number(r.status) === 200) {
          this.$notify({ type: 'primary', message: '修改成功！' })
          item.stars = Number(r.data.stars)
        }
      })
    },
  },
}
</script>

<style lang="less" scoped>
* {
  box-sizing: border-box;
}

.player {
  margin: 0 15px;
  background: #ffffff;
  box-shadow: 0 2px 10px 0 rgba(192, 210, 226, 0.5);
  border-radius: 8px;
  box-sizing: border-box;
  margin-bottom: 20px;
  > div {
    padding: 8px 15px;
    &.top {
      border-bottom: 1px solid #f0f0f0;
      font-size: 16px;
      color: rgba(0, 0, 0, 0.85);
      padding: 12px 15px;
    }
    &.bottom {
      .item {
        margin-bottom: 20px;
        .label {
          font-size: 14px;
          color: #999999;
          margin-bottom: 4px;
        }
        .score-area {
          font-size: 14px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .m-input {
            background: #f9f9f9;
            &.focus {
              border: 1px solid #4197f8;
            }
            &.readonly {
              background: #fff;
            }
            &.rate {
              background: #f9f9f9;
            }
          }
        }
      }
    }
  }
}
</style>
